import { render } from "./register-stage-diversity.vue?vue&type=template&id=55942dfc&scoped=true"
import script from "./register-stage-diversity.vue?vue&type=script&lang=js"
export * from "./register-stage-diversity.vue?vue&type=script&lang=js"

import "./register-stage-diversity.vue?vue&type=style&index=0&id=55942dfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55942dfc"]])

export default __exports__